import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation updateCategoryMutation($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      category {
        ...CategoryCell_category
      }
      errors {
        key
        messages
      }
    }
  }
`;

const updateCategory = (environment, attributes, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: attributes,
    },
    optimisticResponse: {
      updateCategory: {
        category: attributes,
      },
    },
    ...args,
  });
};

export default updateCategory;
